import React from "react";

import ButtonSolid from "../Button/ButtonSolid";
import ButtonGhost from "../Button/ButtonGhost";

const CTA = ({
  heading,
  headingLevel,
  className,
  phonenumber,
  description,
}) => {
  const HeadingTag = headingLevel || "h2";

  return (
    <section className="bg-white p-[15px]  md:min-w-full  md:bg-secondary-400 md:p-0 ">
      <div className="container my-[56px] rounded-3xl bg-secondary-400 md:my-0 md:rounded-none md:bg-transparent ">
        <section
          className={` ${
            className || "p-[15px]  text-center md:text-left lg:py-26"
          }`}
        >
          <div className="mx-auto grid md:grid-cols-2">
            <div>
              <HeadingTag className="mb-4 font-medium">
                {heading || ["Get More Info or Plan a Visit"]}
              </HeadingTag>

              {description ? (
                <p className="lg:text-xl">{description}</p>
              ) : (
                <p className="">
                  We’re here to answer your questions and would love to show you
                  around our community if you’re interested in scheduling a tour
                  of our home in Bankers Hill.
                </p>
              )}
            </div>

            <div className="flex flex-col items-center justify-center space-y-4 md:flex-row md:flex-row md:space-y-0 md:space-x-4">
              <ButtonGhost
                href="tel:(619) 233-8382"
                text={phonenumber}
              />
              <ButtonSolid modal="modal-contact" text="Contact" />
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default CTA;
